import { render, staticRenderFns } from "./DialogConfirm.vue?vue&type=template&id=22f1e18c&scoped=true&"
import script from "./DialogConfirm.vue?vue&type=script&lang=js&"
export * from "./DialogConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f1e18c",
  null
  
)

export default component.exports